import * as L from 'leaflet';
/**
 * The controls management constructor.
 */
export class ManagementControl extends L.Evented {
    /**
     * Create a new controls management instance.
     * @param widget - The M.A.A.P. instance.
     * @param options - The control options.
     */
    constructor(widget, options) {
        super();
        /**
         * The controls' management options.
         */
        this.options = {
            isHorizontal: false,
        };
        /**
         * The available controls.
         */
        this._controls = {};
        this.widget = widget;
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.addEventParent(widget);
        this._controls = {};
    }
    /**
     * Add a control to the map.
     * @param control - The Leaflet control to add.
     */
    addControl(control) {
        var _a;
        if (control.options.name === undefined ||
            this._controls[control.options.name] === undefined) {
            this._controls[(_a = control.options.name) !== null && _a !== void 0 ? _a : 'undefined'] = control;
            this.widget.map._map.addControl(control);
        }
    }
    /**
     * Remove a control from the map.
     * @param name - The unique name of the control to remove.
     */
    removeControl(name) {
        const control = this._controls[name];
        if (control) {
            this.widget.map._map.removeControl(control);
            delete this._controls[name];
        }
    }
    /**
     * Clears the reference to the controls and removes the event parent.
     */
    destroy() {
        this.removeEventParent(this.widget);
        this._controls = {};
    }
}
//# sourceMappingURL=ManagementControl.js.map